export const getActiveContract = (contractsList) => {
  return contractsList.find(cont => cont.isActive);
}
